import {toggleTabIndex} from './utils';


const toggleMegaMenu = (megaMenu) => {
    const isOpen = megaMenu.classList.toggle('open');
    megaMenu.parentElement.classList.toggle('open');
    toggleTabIndex(megaMenu, isOpen);
    if (isOpen) {
        document.addEventListener('click', (e) => handleOutsideClick(e, megaMenu));
    } else {
        document.removeEventListener('click', (e) => handleOutsideClick(e, megaMenu));
    }
}

const handleOutsideClick = (e, megaMenu) => {
    const isOpen = megaMenu.classList.contains('open');
    const isClickInsideElement = megaMenu.contains(e.target);
    const isButtonClick = e.target.classList.contains('js-mega-menu');
    if (isClickInsideElement || isButtonClick || !isOpen) {
        return;
    }
    toggleMegaMenu(megaMenu);
}

const Menu = (el) => {
    const trigger = el;
    const megaMenuId = trigger.getAttribute('aria-controls');
    const megaMenu = document.getElementById(megaMenuId);
    let isOpen = megaMenu.classList.contains('open');
    toggleTabIndex(megaMenu, isOpen);

    el.addEventListener('click', () => toggleMegaMenu(megaMenu));
};

export default Menu;
